var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('PageHeader',{attrs:{"add":{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'sale-add'},"title":_vm.$t('menuitems.sale.text')}}),_c('List',{attrs:{"dataList":_vm.saleData,"edit":{link: 'sale-edit'},"deletes":[_vm.deleted, null],"more":{
          sub: [{
            name: 'sale.contract', icon: 'bx bx-file', link: 'property-contract', column: 'id', target: '_blank'
          },{
            name: 'sale.schedule.view', icon: 'bx bx-table', link: 'payment-schedule-sale', column: 'id', target: '_blank'
          }, {
            name: 'sale.commission', icon: 'bx bx-certification', link: 'property-contract', column: 'id'
          }, {
            name: 'sale.transfer-to-other', icon: 'bx bx-transfer-alt', link: 'sale-transfer', column: 'id'
          }, {
            name: 'property.change-term', icon: 'bx bx-money', link: 'change-term', column: 'id'
          }, {
            name: 'booking.reciept', icon: 'bx bx-dollar-circle', link: 'booking-receipt', column: 'booking_id', target: '_blank'
          }, {
            name: 'property.cancelation.text', icon: 'bx bx-block', link: 'property/cancelation', query: 'saleid', column: 'id'
          }, {
            name: 'property.payment', icon: 'bx bx-table', link: 'payment-list', column: 'id'
          }, {
            name: 'sale.late-payment', icon: 'bx bx-time', link: 'sale-late-payment', column: 'id', show: {column: 'payment_status_id', value: 1}
          }, {
            name: 'sale.late-payment', icon: 'bx bx-time', link: 'sale-late-payment', column: 'id', show: {column: 'payment_status_id', value: 2}
          }, {
            name: 'sale.pay-off-certificate', icon:'bx bxs-file-doc', action: '', link: 'property-unkeep', column: 'id', show: {column: 'payment_status_id', value: 3}
          }] 
        },"filter":{
          search: ['sales.code', 'customers.name', 'customers.name_en', 'properties.code'],
          dropdown: [{
            title: 'property.project',
            field: 'properties.project_id',
            data: this.projectData.data,
            method: function (event) { return _vm.projectChanged(event); },
            default: 1,
            width: 2
          }, {
            title: 'property.group',
            field: 'properties.property_group_id',
            data: this.groupData.data,
          }, {
            title: 'property.floor',
            field: 'properties.project_floor_id',
            show: 'number',
            data: this.floorData.data,
          }],
          date: {
            title: 'general.date',
            field: 'sales.sale_date'
          }
        },"updating":_vm.fetchingStats,"navigate":_vm.pageNavigate,"formats":[{name: 'status', color: true}, {name: 'currency_en'}, {name: 'sale_date', type: 'date'}, {name: 'expire_date', type: 'date'},
                  {name: 'discount', type: 'currency', sign: '$'}, {name: 'sale_price', type: 'currency', sign: '$'}, 
                  {name: 'price', type: 'currency', sign: '$'}, {name: 'deposit', type: 'currency', sign: '$'}],"fields":[ ("code: " + (_vm.$t('sale.code'))), ("customer: " + (_vm.$t('customer.text'))), 
          ("property: " + (_vm.$t('property.text'))), ("sale_date: " + (_vm.$t('general.date'))), ("status: " + (_vm.$t('general.status'))), 
          ("price: " + (_vm.$t('booking.price'))),
          ("discount: " + (_vm.$t('booking.discount'))),
          ("sale_price: " + (_vm.$t('sale.sale-price'))), 
          ("deposit: " + (_vm.$t('booking.deposit'))) ]},on:{"more":_vm.moreClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }